import React from 'react';

export function TextSnippetIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M28.34 10L38 19.66V38H10V10h18.34zm0-4H10c-2.2 0-4 1.8-4 4v28c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V19.66c0-1.06-.42-2.08-1.18-2.82l-9.66-9.66A3.932 3.932 0 0028.34 6zM14 30h20v4H14v-4zm0-8h20v4H14v-4zm0-8h14v4H14v-4z" />
    </svg>
  );
}
